import React, { MouseEvent } from "react";
import { useNavigate } from "react-router-dom";
import { Row, Col, Button } from "react-bootstrap";
import { ActionHandlerFunction } from "@preveil-api";
import {
    Account, DriveEntryType, WatchedLogEntity, getEntityIcon, DriveWatchedErrorMessages, capitalize, WatchLogEventTooltip, DriveUIActionTypes
} from "src/common";
import { Icon } from "src/components";
import _ from "lodash";

type AllProps = {
    current_account: Account;
    entry: WatchedLogEntity;
    handleAction: ActionHandlerFunction;
}

function ListRowComponent(props: AllProps) {
    const { entry, handleAction } = props;
    const navigate = useNavigate();

    // Description: Build the url and navigate to MyPreVeil for now
    function handleRowClick() {
        !entry.is_deleted && navigate(entry.url);
        return false;
    }

    // Description: Build icon for watched row
    function getIconClass() {
        return !!entry.is_error ? "ficon-alert-circle" :
            entry.type !== DriveEntryType.FILE ? "ficon-folder" : (entry.type_class || getEntityIcon(entry.type));
    }

    function handleDetailClick(e: MouseEvent) {
        e.stopPropagation();
        handleAction({ actionType: DriveUIActionTypes.Details, params: entry.node });
    }

    // Description: Build Tooltip
    function getTooltip(): string {
        return !!entry.is_error ? DriveWatchedErrorMessages.error_row_tooltip :
            (_.has(WatchLogEventTooltip, entry.action) ? String(WatchLogEventTooltip[entry.action]) : "");
    }

    return <Row
        data-tooltip-id="pv-tooltip"
        data-tooltip-content={getTooltip() || ""}
        className={(`${!!entry.is_error ? "error-row" : ""}${!!entry.is_deleted ? " cursor-block" : ""}`).trim()}
        onClick={handleRowClick}>
        <Col md="3" className="entry-name col">
            <span>
                <Icon className={getIconClass()} />{entry.name}
            </span>
        </Col>
        <Col md="2" className="order-3">{capitalize(entry.event)}</Col>
        <Col md="3" className="order-4">{entry.user_id}</Col>
        <Col md="3" className="order-5">
            {entry.last_modification_date}
        </Col>
        <Col md="1" className="order-md-5 order-2">
            <Button
                variant="no-outline-secondary btn-icon"
                size="sm"
                aria-label="Watched Items"
                data-tooltip-id="dd-tooltip"
                data-tooltip-content="View this item's Recent Changes"
                data-tooltip-place="right"
                onClick={(e) => (handleDetailClick(e))}  >
                <Icon className="ficon-more-vertical" />
            </Button>
        </Col>
    </Row>;
}

export default React.memo(ListRowComponent);